module.exports = __webpack_public_path__ + "img/组 126(8).59cdb589.png";